import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_FormattingCard = _resolveComponent("FormattingCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_dialog, {
      "model-value": _ctx.show,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
      "max-width": "1200px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("Execution History")
              ])),
              _: 1,
              __: [4]
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_data_table, {
                  headers: _ctx.headers,
                  items: _ctx.results,
                  loading: _ctx.loading,
                  "item-key": "id",
                  density: "compact"
                }, {
                  [`item.status`]: _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: item.status === 'success' ? 'green' : 'red',
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.status), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  [`item.executedAt`]: _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(new Date(item.executedAt).toLocaleString()), 1)
                  ]),
                  [`item.actions`]: _withCtx(({ item }) => [
                    (item.response)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          size: "small",
                          onClick: ($event: any) => (_ctx.showResult(item))
                        }, {
                          default: _withCtx(() => _cache[5] || (_cache[5] = [
                            _createTextVNode("See Result")
                          ])),
                          _: 2,
                          __: [5]
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  [`item.error`]: _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(item.error || 'N/A'), 1)
                  ]),
                  _: 2
                }, 1032, ["headers", "items", "loading"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  text: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode("Close")
                  ])),
                  _: 1,
                  __: [6]
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showResultDialog,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showResultDialog) = $event)),
      "max-width": "900px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(" Run Result - " + _toDisplayString(_ctx.selectedResult ? new Date(_ctx.selectedResult.executedAt).toLocaleString() : ''), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "result-dialog-text" }, {
              default: _withCtx(() => [
                _createVNode(_component_FormattingCard, {
                  content: _ctx.selectedResult ? _ctx.selectedResult.response : '',
                  expanded: 'true'
                }, null, 8, ["content"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  text: "",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showResultDialog = false))
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("Close")
                  ])),
                  _: 1,
                  __: [7]
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}